export default function HeroSection() {
  return (
    <section className="relative h-[480px] md:h-[580px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20architect%20workspace%20with%20large%20architectural%20blueprints%20spread%20across%20a%20clean%20wooden%20desk%2C%20detailed%20floor%20plans%20and%20elevation%20drawings%2C%20a%20laptop%20displaying%203D%20rendered%20modern%20residential%20building%2C%20small%20scale%20models%20of%20steel%20frame%20houses%2C%20soft%20warm%20natural%20light%20streaming%20through%20tall%20windows%2C%20cream%20and%20champagne%20gold%20color%20tones%20throughout%20the%20room%2C%20minimalist%20high%20end%20interior%20design%20office%2C%20no%20people%2C%20elegant%20and%20organized%20planning%20environment%2C%20professional%20real%20estate%20development%20studio%20photography&width=1440&height=580&seq=process-hero-2026&orientation=landscape"
          alt="服務流程與收費 - 建築規劃"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/55 via-black/40 to-black/60" />
      </div>

      <div className="relative z-10 container-main w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl">
          <span className="inline-block px-4 py-1.5 bg-champagne/20 backdrop-blur-sm text-champagne text-base font-semibold tracking-wider rounded-full mb-5">
            SERVICE PROCESS
          </span>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-cream leading-tight mb-5">
            服務流程與收費
          </h1>
          <p className="text-base md:text-base text-cream/85 max-w-2xl leading-relaxed mb-8">
            從基地評估到交屋入住，Chronos Space 提供全程透明的自地自建服務流程，讓您清楚掌握每個階段的進度與費用，安心規劃您的理想住宅。
          </p>
          <a
            href="https://lin.ee/OpssTIM"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-champagne text-graphite rounded-full text-base font-semibold transition-all duration-300 hover:bg-champagne/90 hover:-translate-y-0.5 whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-fill" />
            </span>
            加入 LINE 免費諮詢
          </a>
        </div>
      </div>
    </section>
  );
}